import { useEffect, useRef, useState } from 'react'

export type LoginMode = 'password' | 'magic'

type Callbacks = {
  /** Reporte l'e-mail déjà saisi dans le formulaire du mode suivant. */
  carryEmail: (next: LoginMode) => void
  /** Efface ce qui ne vaut que pour le mode quitté (erreur, lien envoyé). */
  reset: () => void
  /** Donne le focus au premier champ du mode affiché. */
  focus: (mode: LoginMode) => void
}

/**
 * Bascule entre connexion par mot de passe et par lien. Le bouton qui avait le
 * focus disparaît avec le mode quitté : sans reprise, le focus tombait sur
 * `body` et le clavier repartait du haut de la page (RGAA 7.1).
 */
export function useLoginMode({ carryEmail, reset, focus }: Callbacks) {
  const [mode, setMode] = useState<LoginMode>('password')
  const focusAfterSwitch = useRef(false)
  const latestFocus = useRef(focus)
  useEffect(() => {
    latestFocus.current = focus
  })

  useEffect(() => {
    if (!focusAfterSwitch.current) return
    focusAfterSwitch.current = false
    latestFocus.current(mode)
  }, [mode])

  const switchMode = (next: LoginMode) => {
    focusAfterSwitch.current = true
    reset()
    carryEmail(next)
    setMode(next)
  }

  return { mode, switchMode }
}
